import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatRut(rut: string): string {
  const cleaned = rut.replace(/[^0-9kK]/g, '')
  if (cleaned.length < 2) return cleaned

  const body = cleaned.slice(0, -1)
  const dv = cleaned.slice(-1).toUpperCase()
  const formatted = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return `${formatted}-${dv}`
}

export function formatKilos(kilos: number): string {
  if (kilos >= 1000) {
    return `${(kilos / 1000).toFixed(2)} t`
  }
  return `${kilos.toFixed(1)} kg`
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP',
    minimumFractionDigits: 0,
  }).format(amount)
}

export function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    scheduled:   'bg-[#dff24b] text-[#383f2d]',
    confirmed:   'bg-[#b9d94a] text-[#383f2d]',
    completed:   'bg-[#e6e6e6] text-[#383f2d]',
    rescheduled: 'bg-[#7c8c43] text-white',
    cancelled:   'bg-[#383f2d]/10 text-[#383f2d]/50',
  }
  return colors[status] ?? 'bg-[#e6e6e6] text-[#383f2d]'
}

export function getStatusDotColor(status: string): string {
  const colors: Record<string, string> = {
    scheduled:   'bg-[#b9d94a]',
    confirmed:   'bg-[#7c8c43]',
    completed:   'bg-[#383f2d]/40',
    rescheduled: 'bg-[#dff24b]',
    cancelled:   'bg-[#383f2d]/25',
  }
  return colors[status] ?? 'bg-[#383f2d]/25'
}
